import React from 'react'
import { THEME } from 'utils'

const ListSection = ({ header, subheader, img, list, subLists, styles }) => {
  return (
    <div className='listSection' style={styles}>
      {header && <h2>{header}</h2>}
      {img && <img src={img} alt={header + '_img'} />}
      <h4>{subheader}</h4>
      <ul className='listSection__list'>
        {list.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
      {subLists &&
        subLists.map(({ header, items }, idx) => (
          <div key={idx} className='listSection__subList'>
            <h3>{header}</h3>
            <ul className='listSection__list'>
              {items.map((item, items_idx) => (
                <li key={items_idx} style={{ listStyleType: typeof item === 'string' ? 'inherit' : 'none' }}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      <style>{`
          .listSection {
              padding: 2.5rem 5rem;
              width: 100%;
              background-color: #f5f5f5;
              display: flex;
              flex-direction: column;
          }
          .listSection:nth-child(odd) {
              background-color: #fff;
          }
          .listSection h2 {
              margin: 0;
              font-size: 1.35rem;
          }
          .listSection img {
              margin: 25px 0 5px;
              align-self: center;
              width: 90%;
          }
          .listSection h4 {
              margin: 20px 0 25px;
              color: #de4444;
              font-size: 1rem;
          }
          .listSection__list {
              margin: 0;
              list-style-type: square;
              font-weight: 600;
              font-size: .95rem;
          }
          .listSection__list li {
              margin-top: 18px;
          }
          .listSection__list li:first-of-type {
              margin: 0;
          }
          .listSection__subList {
              margin-top: 25px;
              padding-left: 80px;
          }
          .listSection__subList h3 {
              color: #de4444;
              margin-top: 0;
          }
          @media (max-width: ${THEME.BREAKPOINTS.XL}px) {
              .listSection {
                  padding: 2.5rem;
              }
          }
          @media (max-width: ${THEME.BREAKPOINTS.SM}px) {
              .listSection {
                  padding: 2rem 1.5rem;
              }
              .listSection h2 {
                  font-size: 1.1rem;
              }
              .listSection h4 {
                  margin: 15px 0 20px;
                  font-size: .8rem;
              }
              .listSection__list {
                  font-size: .75rem;
                  padding-inline-start: 30px;
              }
              .listSection__list li {
                  width: 90%;
              }
              .listSection__subList {
                  padding-left: 40px;
              }
              .listSection__subList ul {
                  padding-inline-start: 30px;
              }
              .listSection__subList h3 {
                  font-size: 1rem;
              }
          }
      `}</style>
    </div>
  )
}

export default ListSection
